// src/components/pages/portfolios/partials/PortfolioDetailCharts.js (수정된 코드)

import { 
  ResponsiveContainer, LineChart, Line, AreaChart, Area, 
  CartesianGrid, XAxis, YAxis, Tooltip
} from 'recharts';
import styles from './../style/PortfolioDetail.module.css';

export default function PortfolioCharts({ timeSeries, t }) {
  const cumulativeValues = timeSeries?.cumulativeValues || [];
  const drawdownHistory = timeSeries?.drawdownHistory || [];

  return (
    <>
      {/* 1. 누적 수익률 (Line Chart) */}
      {cumulativeValues.length > 0 && (
        <div className={styles.chartBlock}>
          <h3 className={styles.subTitle}>{t('portfolioDetail.cumulativeValueTitle')}</h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={cumulativeValues} margin={{ top: 20, right: 10, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis width={60} domain={['auto', 'auto']} />
              <Tooltip formatter={val => Math.round(val).toLocaleString(0)} contentStyle={{ color: '#fff', backgroundColor: '#333' }} />
              <Line type="monotone" dataKey="value" stroke="#ffe119" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* 2. 낙폭 (Drawdown Chart) */}
      {drawdownHistory.length > 0 && (
        <div className={styles.chartBlock}>
          <h3 className={styles.subTitle}>{t('portfolioDetail.drawdownTitle')}</h3>
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart data={drawdownHistory} margin={{ top: 20, right: 10, left: 10, bottom: 5 }}>
              <defs>
                <linearGradient id="gradDD" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#FF4444" stopOpacity={0.8}/>
                  <stop offset="95%" stopColor="#FF4444" stopOpacity={0}/>
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis domain={['auto', 0]} tickFormatter={v => `${(v * 100).toFixed(0)}%`} width={60} />
              <Tooltip formatter={v => `${(v * 100).toFixed(2)}%`} />
              <Area type="monotone" dataKey="drawdown" stroke="#FF4444" fill="url(#gradDD)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </>
  );
}